export default "__VITE_ASSET__sappW2YA__"